module.exports = __webpack_public_path__ + "img/internet.946f492c.png";